import { render, staticRenderFns } from "./VideoUploadModal.vue?vue&type=template&id=1afa45be"
import script from "./VideoUploadModal.vue?vue&type=script&lang=js"
export * from "./VideoUploadModal.vue?vue&type=script&lang=js"
import style0 from "./VideoUploadModal.vue?vue&type=style&index=0&id=1afa45be&prod&lang=stylus"
import style1 from "./VideoUploadModal.vue?vue&type=style&index=1&id=1afa45be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports